import React, { useEffect, useState } from 'react';
import firebase, { firebaseAnalytics }  from './Firebase';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Dropdown, Spinner } from 'react-bootstrap';
import Recensione from './Recensione';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';


export default function Reviews(filter) {
  const [reviews, setReviews] = useState([]);
  const [filteredReviews, setFilteredReviews] = useState([]);
  const [aziende, setAziende] = useState({})
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filtro, setFiltro] = useState('Varietà');
  const [searchedRev, setSearchedRev] = useState();
  const ref = firebase.firestore().collection('recensioni');
  const refAz = firebase.firestore().collection('aziende')
  const [tipo, setTipo] = useState('');
  const [all, setAll] = useState(true);
  const [weed, setWeed] = useState(false);
  const [hash, setHash] = useState(false);
  const refs = new Map();
  const history = useHistory();
  var search_filter = !history.location.pathname.split("/")[1].includes("recensioni") || history.location.pathname.split("/")[2] === undefined ? "all":  filter.filter 
  history.listen(url =>  search_filter = url.pathname.split("/")[2] )
  const queryParams = new URLSearchParams(history.location.search)
  const id = queryParams.get("id")

  useEffect(() => {
    firebaseAnalytics.logEvent("reviews_tab_visited");
    firebaseAnalytics.setCurrentScreen("reviews_tab")
    refAz.onSnapshot((query) => {
      updateAziende(query)}
      )
    ref.onSnapshot(query => {
      setLoading(true)
      updateState(query)
      setLoading(false)}
      )
  }, []);

  const updateState = query => {
      const items = [];
      query.forEach(doc => items.push(doc.data()));
      items
      .sort(function compareNumbers(a, b) {
        return (b.data - a.data );
      })
      setReviews(items)
      setFilteredReviews(items)
      switchFilter(items);
    
  }
  
  const updateAziende = query => {
    var items = {}
    query.forEach(item => {
        items[item.data().nome] = item.data()
    })
    setAziende(items)
}

  const searchRevs = (string) => {
    
      if(filtro==="Varietà")
        setFilteredReviews( 
          reviews
          .filter( rev => rev.tipo.includes(tipo) && rev.varietà.toLowerCase().includes(string.toLowerCase()))
          .sort(function compareNumbers(a, b) {
            return (b.data - a.data );
          })
        );
      else if (filtro==="Azienda")
        setFilteredReviews( 
          reviews
          .filter( rev => rev.tipo.includes(tipo) && rev.marca.toLowerCase().includes(string.toLowerCase()))
          .sort(function compareNumbers(a, b) {
            return (b.data - a.data );
          })
        );
  }

  const switchFilter = (items) => {
    let revs
    switch (search_filter) {
      default:
        changeCheckbox("all")
        revs = reviews.length === 0 ? items : reviews ;
        break;

      case "weed":
        changeCheckbox("weed")
        revs = reviews.length === 0 ? items.filter(review => review.tipo === "Erba") 
        : reviews.filter(review => review.tipo === "Erba") ; 
        break;

      case "hash":
        changeCheckbox("hash")
        revs = reviews.length === 0 ? items.filter(review => review.tipo === "Hash") 
        : reviews.filter(review => review.tipo === "Hash") ; 
        break;
    }
    setFilteredReviews(revs);

  }

  const changeCheckbox = (search_filter) => {
    switch (search_filter) {
      case "all":
        setAll(true);
        setWeed(false);
        setHash(false);
        setTipo('');
        break;
  
      case "weed":
        setAll(false);
        setWeed(true);
        setHash(false);
        setTipo('Erba');
        break;
  
      case "hash":
        setAll(false);
        setWeed(false);
        setHash(true);
        setTipo('Hash');
        break;
    }
   }

  const ScrollDemo = id => {
    refs.get(id).current.scrollIntoView()
 }

  const renderSingleReview = () => {
    var rece = null
    reviews.forEach( rev => {
      if(rev.id === id){ rece = rev }
    })
    if(rece === null) {history.replace("/");} 
    else {return <Recensione review={rece} az={aziende[rece.marca]} type={"card"}/>}
  }

  return (
    <>
    {id !== null && reviews.length !== 0 ? 
     <div style={{justifyContent: "center", alignContent:"center"}}>
            <div style={{color:"lightgrey"}}>
              <FontAwesomeIcon icon={faTimesCircle}  style={{cursor: "pointer"}} onClick={() => history.push("/recensioni/all") }  /> 
              <text style={{ marginLeft: "10px", cursor: "pointer"}} onClick={() => history.push("/recensioni/all") } >
                  Torna alle recensioni
              </text>  
            </div>  
            <div class="row" style={{justifyContent: "center", alignContent:"center"}}>
              {renderSingleReview()}
            </div>
     </div>
    :
    <>
      <div class="row">
        <div className="filters" >
          <div class="row" style={{justifyContent: "center", alignContent:"center"}}>
            <input className='input' type='text' placeholder='🔍 Cerca...' 
              onChange={event => {
                setSearch(event.target.value);
                searchRevs(event.target.value)
              }}
            />
            <Dropdown className='input-varieta' >
              <Dropdown.Toggle id="dropdown-basic" variant='secondary' style={{ backgroundColor: "#2c2c32", boxShadow: 'none', borderColor: "#2c2c32" }}>{filtro}</Dropdown.Toggle>
              <Dropdown.Menu>
                {filtro === "Azienda" ? 
                  <Dropdown.Item onClick={() => setFiltro('Varietà')}>Varietà</Dropdown.Item>
                :
                  <Dropdown.Item onClick={() => setFiltro('Azienda')} style={{ color: "white" }}>Azienda</Dropdown.Item>
                }
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div class="row" sm={10} style={{color: "white", paddingInline: 35, marginTop: "2%", marginBottom: "2%"}}>
            <Form.Check
              inline type="radio" label="Tutto" name="formHorizontalRadios" id="formHorizontalRadios1" checked={all} 
              onClick={() => {history.push("/recensioni/all"); switchFilter()}}
            />
            <Form.Check
              inline type="radio" label="Erba🍁" name="formHorizontalRadios" id="formHorizontalRadios2" checked={weed}
              onClick={() => {history.push("/recensioni/weed"); switchFilter()}}
            />
            <Form.Check
              inline type="radio" label="Hash🍫" name="formHorizontalRadios" id="formHorizontalRadios3" checked={hash}
              onClick={() => {history.push("/recensioni/hash"); switchFilter()}} 
            />
          </div>
          <div style={{alignSelf: "center"}} ><text style={{color: "white", display: "inline", paddingLeft: "2%", whiteSpace: "nowrap" }}> recensioni: {filteredReviews.length}</text></div>
        </div>
      </div>

      {loading ? 
        <h2 style={{ color: 'white' }}><Spinner animation="grow" /></h2>:
        <div className="conteinerRecensioni">
          {filteredReviews.map(recensione => {
            
            return <Recensione review={recensione} az={aziende[recensione.marca]} type={"card"}/>
          }
          )}
        </div>
      }

      {!loading && filteredReviews.length === 0 && 
        <h3 style={{ color: 'white' }}>
          Nessun risultato.
        </h3>}
        </>
    }
    </>
  );
}